import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Pool, User } from '@freelancer/datastore/collections';
import { ButtonColor } from '@freelancer/ui/button';
import { Margin } from '@freelancer/ui/margin';
import { isDefined } from '@freelancer/utils';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-user-profile-expert-communities',
  template: `
    <fl-card [flMarginBottom]="Margin.MID">
      <fl-card-header-title i18n="Expert Communities Card Title">
        Expert Communities
      </fl-card-header-title>

      <fl-card-header-right *ngIf="isViewerProfileOwner$ | flAsync">
        <fl-button
          i18n="Manage communities button"
          flTrackingLabel="UserProfileManageCommunities"
          [color]="ButtonColor.SECONDARY"
          [link]="'/users/settings.php'"
          [fragment]="'ExpertCommunities'"
        >
          Manage
        </fl-button>
      </fl-card-header-right>

      <app-user-profile-expert-communities-badge
        *ngIf="hasFacebookCertification$ | flAsync"
        i18n-certificationName="Facebook Certified Ads Product Developer 1"
        certificationName="Facebook Certified Ads Product Developer 1"
        [badgeSrc]="'profile/expert-communities/facebook/ads-dev-1.png'"
        [community]="'Facebook'"
        [issuer]="'Facebook blueprint'"
        [link]="'https://www.facebook.com/business/learn/facebook-ads-pixel'"
        [trackingLabel]="'facebookPixelLink'"
      >
      </app-user-profile-expert-communities-badge>
    </fl-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileExpertCommunitiesComponent implements OnInit {
  ButtonColor = ButtonColor;
  Margin = Margin;

  @Input() user$: Rx.Observable<User>;
  @Input() isViewerProfileOwner$: Rx.Observable<boolean>;

  hasFacebookCertification$: Rx.Observable<boolean>;

  ngOnInit(): void {
    this.hasFacebookCertification$ = this.user$.pipe(
      map(
        user =>
          // TODO: replace it after the certifications have implemented
          // Right now, To be in FACEBOOK pool means that user
          // has facebook certification
          isDefined(user.poolIds) && user.poolIds.includes(Pool.FACEBOOK),
      ),
    );
  }
}
